var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title mt-5" }, [
      _c("h3", { staticClass: "d-flex justify-content-center header" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("headers.questionnaire")) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "fade-transition",
          { attrs: { duration: 200, mode: "out-in" } },
          [
            _vm.currentQuestionIndex !== undefined
              ? _c("question", {
                  key: _vm.currentQuestionIndex,
                  attrs: {
                    question: _vm.currentQuestion,
                    selectedAnswer:
                      _vm.form.data.answers[_vm.currentQuestionIndex]
                  },
                  on: { answerSelected: _vm.onAnswerSelected }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-content-center mt-5 mb-5" },
          _vm._l(_vm.questionnaire.questions.length, function(page) {
            return _c("span", {
              key: page - 1,
              staticClass: "pagination-dot",
              class: { active: page - 1 === _vm.currentQuestionIndex }
            })
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "actions d-flex",
            class: {
              "justify-content-between": _vm.currentQuestionIndex > 0,
              "justify-content-end": _vm.currentQuestionIndex === 0
            }
          },
          [
            _vm.currentQuestionIndex > 0
              ? _c(
                  "button",
                  {
                    staticClass: "button primary",
                    on: { click: _vm.previousAction }
                  },
                  [_vm._v(_vm._s(_vm.previousActionText))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button primary",
                class: {
                  disabled:
                    _vm.form.data.answers[_vm.currentQuestionIndex] ===
                    undefined
                },
                on: { click: _vm.nextAction }
              },
              [_vm._v(_vm._s(_vm.nextActionText))]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }